import { render, staticRenderFns } from "./Circular.vue?vue&type=template&id=5d1038c4&scoped=true"
import script from "./Circular.vue?vue&type=script&lang=js"
export * from "./Circular.vue?vue&type=script&lang=js"
import style0 from "./Circular.vue?vue&type=style&index=0&id=5d1038c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1038c4",
  null
  
)

export default component.exports